import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './components/App';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import {
  EventType,
  EventMessage,
  AuthenticationResult,
  InteractionType
} from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { graphRequest, apiRequest } from './config/authConfig';
import { msalInstance } from './auth/msalInstance';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const router = createBrowserRouter([{ path: '*', element: <App /> }]);

msalInstance
  .initialize()
  .then(() => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }

    msalInstance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
      }
    });

    root.render(
      <MsalProvider instance={msalInstance}>
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={apiRequest}>
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={graphRequest}>
            <RouterProvider router={router} />
          </MsalAuthenticationTemplate>
        </MsalAuthenticationTemplate>
      </MsalProvider>
    );
  })
  .catch(() => {});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
